import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/internal/operators/map';
import { AuthenticationService } from '../services/authentication.service';
import { PermissionsService } from '../services/permissions.service';

export const authenticationGuard: CanActivateFn = (state, route) => {
	if (!state.routeConfig?.path?.includes('account/login')) {
		return inject(PermissionsService)
			.checkUserAccessPermission(route.url)
			.pipe(
				map(response => {
					return response;
				})
			);
	}
	return true;
};
